export enum StartedFrom {
    SEARCH_APP = 'search-app',
    PRODUCTS = 'products',
    YARU = 'yaru_morda_touch', // фид на морде
    YARU_EXP = 'expyaru', // фид на странице заказов и алисы
    YARU_PRODUCTS = 'zero_goods', // фид на товарной морде
}

export interface MetaState {
    startedFrom: StartedFrom | null | undefined;
}
